import { Trans } from "react-i18next";
import { useGetHeartbeatQuery } from "../api/HeartbeatApi";

function Heartbeat () {

  const {data} = useGetHeartbeatQuery();
  if (!data) {
    return null;
  }

  return (<div className={"m-8"}>
    <h1 className={"text-xl md:text-3xl font-unleashed"}><Trans>Unleashed Statuses</Trans></h1>
    <div className={"grid grid-cols-2 grid-rows-1"}>
      <div>
        <span className={"font-bold"}><Trans>Membership</Trans>:</span>
        <p>{data?.membership}</p>
      </div>
      <div>
        <span className={"font-bold"}><Trans>Warehouse</Trans>:</span>
        <p>{data?.warehouse}</p>
      </div>
    </div>
  </div>);
}

export default Heartbeat;
